"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsSchema = void 0;
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-shadow */
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const cloneDeepWith_1 = __importDefault(require("lodash/cloneDeepWith"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const reduce_1 = __importDefault(require("lodash/reduce"));
const map_1 = __importDefault(require("lodash/map"));
const forEach_1 = __importDefault(require("lodash/forEach"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const merge_1 = __importDefault(require("lodash/merge"));
const keys_1 = __importDefault(require("lodash/keys"));
// eslint-disable-next-line @typescript-eslint/naming-convention
const _ = {
    cloneDeep: cloneDeep_1.default,
    cloneDeepWith: cloneDeepWith_1.default,
    isPlainObject: isPlainObject_1.default,
    isEmpty: isEmpty_1.default,
    isNil: isNil_1.default,
    reduce: reduce_1.default,
    map: map_1.default,
    forEach: forEach_1.default,
    isObject: isObject_1.default,
    isArray: isArray_1.default,
    merge: merge_1.default,
    keys: keys_1.default,
};
const Ajv = require("ajv");
class FieldsSchema {
    constructor(schema) {
        this.schema = _.cloneDeep(schema);
    }
    getValues() {
        return this.getDeepProperty("value");
    }
    validate(values, coerceTypes) {
        const ajv = new Ajv({ removeAdditional: true, coerceTypes }); // options can be passed, e.g. {allErrors: true}
        try {
            ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
        }
        catch (e) {
            // already added schema
        }
        const valid = ajv.validate(this.schema, values);
        if (!valid) {
            throw new Error(`Form data is in wrong format. Validation errors: ${JSON.stringify(ajv.errors)}`);
        }
    }
    putValues(values) {
        // Validation with coercion modifies "values", so clone it beforehand
        const fieldsData = _.cloneDeep(values);
        this.validate(fieldsData, true);
        const propertyName = "value";
        return this.putDeepProperty(propertyName, fieldsData);
    }
    /**
     * Deeply remove property from schema.
     * E.g. removeDeepProperty("value") for schema
     *   { a: { value: { v: v }, properties: { nested: { value: val }}}}
     * will modify schema to
     *   { a: { properties: { nested: {}}}}
     *
     * @param {string} propertyName
     * @returns
     * @memberof FieldsSchema
     */
    removeDeepProperty(propertyName) {
        function omitProperty(value) {
            if (value && typeof value === "object") {
                if (value[propertyName]) {
                    delete value[propertyName];
                }
            }
        }
        this.schema = _.cloneDeepWith(_.cloneDeep(this.schema), omitProperty);
        return this;
    }
    /**
     * Sets properties in Schema.
     * For example, putting properties { "propName": "new" } in schema
     * { type: "object", properties: { "nested": { name: "Name" } }}
     * would mutate the schema to
     * { type: "object", properties: {
     *    "nested": { name: "Name", "propName": "new" }
     * }}
     *
     * @param {string} propertyName
     * @param {Dictionary<any>} values - Property values
     * @returns
     * @memberof FieldsSchema
     */
    putDeepProperty(propertyName, values) {
        const iterateDeep = (schema, values, subpropertyName = "properties") => {
            // clear all additional properties if their value is present,
            // as we might have deleted some of them
            if (!_.isEmpty(schema.additionalProperties) && propertyName === "value") {
                delete schema[propertyName];
            }
            _.forEach(values, (value, key) => {
                var _a, _b;
                if (_.isPlainObject(value) &&
                    schema.properties &&
                    schema.properties[key]) {
                    // Go down a level if the value is an object
                    iterateDeep(schema.properties[key], value, "properties");
                }
                else if (_.isArray(value) &&
                    schema.properties &&
                    schema.properties[key] &&
                    schema.properties[key].items &&
                    _.isArray(schema.properties[key].items)) {
                    // Tuple array
                    iterateDeep(schema.properties[key], value, "items");
                }
                else if (_.isPlainObject(value) &&
                    schema.items &&
                    /// @ts-ignore - explicit any
                    schema.items[key]) {
                    // The value is an object in tuple array
                    /// @ts-ignore - explicit any
                    iterateDeep(schema.items[key], value, "properties");
                }
                else {
                    // List Array or atomic value
                    // Only add the value if the key exists
                    // Dont use _.has and _.set here because
                    // it fails if "key" has square brackets in it
                    if (!_.isNil((_b = (_a = schema) === null || _a === void 0 ? void 0 : _a[subpropertyName]) === null || _b === void 0 ? void 0 : _b[key])) {
                        schema[subpropertyName][key][propertyName] = value;
                    }
                    // if the key doesn't exist but we allow additional properties
                    else if (!_.isEmpty(schema.additionalProperties)) {
                        // put the value in the propertyName (e.g. endUserField)
                        // under key (e.g. firstName)
                        if (!schema[propertyName]) {
                            schema[propertyName] = {};
                        }
                        schema[propertyName][key] = value;
                    }
                }
            });
        };
        // This will modify the schema in place
        iterateDeep(this.schema, values);
        return this;
    }
    /**
     * Retrieves all values of property from Schema.
     * For example, retrieving all names from
     * { type: "object", properties: { "nested": { name: "Name" } }}
     * would return { "nested": "Name" }
     *
     * @param {*} property
     * @param {boolean} options.mergeWithNested
     * If the property value (must be object) should be merged with nested values.
     * I.e. getDeepProperty({ a: { value: { v: v }, properties: { nested: { value: val }}}}) outputs:
     *   - { a: { v: v } } with mergeWithNested = false
     *   - { a: { v: v, nested: val }} with mergeWithNested = true
     * @param {boolean} options.mergeArraysWithNested
     * Should we merge arrays with nested values
     * I.e. with schema:
     * {
     *   type: "object",
     *   properties: {
     *     arr: {
     *       type: "array",
     *       items: [{ type: "string", value: "nested" }],
     *       value: { someKey: "top" }
     *     }
     *   }
     * }
     * getDeepProperty("value") outputs:
     *   - { someKey: "top" } with mergeArraysWithNested = false
     *   - { arr: ["nested"]} but arr will also have someKey prop set to "top"
     *      with mergeArraysWithNested = true
     *
     * @param {boolean} keepEmptyElementsInArrays
     * Should we keep empty elements in array.
     * With shcema
     * {
     *   type: "object",
     *   properties: {
     *     arr: {
     *       type: "array",
     *       items: [
     *         { type: "string", value: undefined },
     *         { type: "string", value: "123" }
     *       ],
     *       value: { someKey: "top" }
     *     }
     *   }
     * }
     * getDeepProperty("value") outputs:
     *   - ["123"] with keepEmptyElementsInArrays = false
     *   - [undefined, "123"] with keepEmptyElementsInArrays = false
     *
     * @returns {Dictionary<any>}
     * @memberof FieldsSchema
     */
    getDeepProperty(propertyName, options = {
        mergeWithNested: false,
        mergeArraysWithNested: false,
        keepEmptyElementsInArrays: false,
    }) {
        const reduceDeep = (schema) => {
            // Empty schema, return undefined for the property
            if (!schema || _.keys(schema).length === 0) {
                return undefined;
            }
            // If we have the property set in the schema,
            /// @ts-ignore - implicit any
            const propertyOwnValue = schema[propertyName];
            let mergeWithNested = options.mergeWithNested;
            if (propertyOwnValue !== undefined) {
                // always merge values when additionalProperties are present
                if (_.isObject(propertyOwnValue) &&
                    !_.isEmpty(schema.additionalProperties) &&
                    propertyName === "value") {
                    mergeWithNested = true;
                }
                // if we don't want/can't to merge it with children's property,
                // return it.
                const canNotMergeObject = !mergeWithNested ||
                    !_.isObject(propertyOwnValue) ||
                    schema.type !== "object";
                const canNotMergeArray = !options.mergeArraysWithNested ||
                    !_.isObject(propertyOwnValue) ||
                    schema.type !== "array";
                if (canNotMergeObject && canNotMergeArray) {
                    return propertyOwnValue;
                }
            }
            // Try to get the property from the nested schemas
            // Go down a level if the value is an object
            if (schema.type === "object") {
                const nestedValue = _.reduce(schema.properties, (acc, prop, key) => {
                    const nestedProperties = reduceDeep(prop);
                    if (nestedProperties !== undefined) {
                        if (acc === undefined) {
                            // tslint:disable-next-line: no-parameter-reassignment
                            acc = {};
                        }
                        acc[key] = nestedProperties;
                    }
                    return acc;
                }, undefined);
                // If we should merge nested
                if ((_.isObject(nestedValue) || _.isObject(propertyOwnValue)) &&
                    mergeWithNested) {
                    return _.merge({}, propertyOwnValue, nestedValue);
                }
                return nestedValue;
            }
            if (schema.type === "array") {
                let result;
                // Tuple array
                if (_.isArray(schema.items)) {
                    result = _.reduce(schema.items, (acc, prop) => {
                        const nestedProperties = reduceDeep(prop);
                        if (nestedProperties || options.keepEmptyElementsInArrays) {
                            if (!acc) {
                                // tslint:disable-next-line: no-parameter-reassignment
                                acc = [];
                            }
                            acc.push(nestedProperties);
                        }
                        return acc;
                    }, undefined);
                }
                else {
                    // List array
                    const arrayItems = reduceDeep(schema.items);
                    // if the array is empty,
                    // arrayItems will be undefined
                    if (arrayItems !== undefined) {
                        result = [arrayItems];
                    }
                }
                // Try to add additional properties to the array,
                // if user explicitly specified they are needed
                const canMergeNested = options.mergeArraysWithNested && _.isObject(propertyOwnValue);
                if (canMergeNested) {
                    result = _.merge([], result, propertyOwnValue);
                }
                return result;
            }
            // return default property value (which will be undefined by default)
            return propertyOwnValue;
        };
        return reduceDeep(this.schema) || {};
    }
    getNumberOfFields() {
        const reduceDeep = (schema) => {
            // Empty schema
            if (!schema || _.keys(schema).length === 0) {
                return 0;
            }
            // Go down a level if the value is an object
            if (schema.type === "object") {
                const subSchemasFieldsNum = _.map(schema.properties, (prop) => reduceDeep(prop)).reduce((a, b) => a + b, 0);
                return subSchemasFieldsNum;
            }
            if (schema.type === "array") {
                // Tuple array
                if (_.isArray(schema.items)) {
                    const subSchemasFieldsNum = _.map(schema.items, (prop) => reduceDeep(prop)).reduce((a, b) => a + b, 0);
                    return subSchemasFieldsNum;
                }
                // List array
                return reduceDeep(schema.items);
            }
            // Array or atomic value
            return 1;
        };
        return reduceDeep(this.schema);
    }
    /**
     * Map all fields through the provided function
     */
    mapFields(mapper) {
        function mapField(value, key) {
            // Field is an atomic value, so map any non null/array/object fields
            if ((value === null || value === void 0 ? void 0 : value.type) &&
                value.type !== "null" &&
                value.type !== "object" &&
                value.type !== "array") {
                return mapper(value, key);
            }
            // returning nothing will use the original clone strategy
        }
        this.schema = _.cloneDeepWith(_.cloneDeep(this.schema), mapField);
        return this;
    }
}
exports.FieldsSchema = FieldsSchema;
//# sourceMappingURL=fields_schema.js.map